import { User, UserSearchResult } from '../types/User';
import authService from './AuthService';
import { getApiUrl } from '../utils/env';

const API_BASE_URL = getApiUrl();

// Log API-Konfiguration beim Laden des Services
console.log('🔧 UserService Konfiguration:');
console.log('   API_BASE_URL (verwendet):', API_BASE_URL);
if (!process.env.REACT_APP_API_URL && !window.__ENV__?.REACT_APP_API_URL) {
  console.warn('⚠️  Keine API URL konfiguriert - verwende Default');
}

class UserService {
  private async getAuthHeaders() {
    const token = await authService.getAccessTokenAsync();
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };
  }

  async registerOrUpdateCurrentUser(): Promise<User> {
    console.log('👤 API Call: POST', `${API_BASE_URL}/user`);
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/user`, {
      method: 'POST',
      headers
    });

    console.log('👤 API Response:', response.status, 'POST /user');
    if (!response.ok) {
      console.error('❌ User API Error:', response.status, 'POST /user');
      throw new Error(`Fehler bei der Benutzerregistrierung: ${response.status}`);
    }

    return response.json();
  }

  async getAllUsers(): Promise<User[]> {
    console.log('👤 API Call: GET', `${API_BASE_URL}/users`);
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/users`, {
      method: 'GET',
      headers
    });

    console.log('👤 API Response:', response.status, 'GET /users');
    if (!response.ok) {
      console.error('❌ Users API Error:', response.status, 'GET /users');
      throw new Error(`Fehler beim Abrufen der Benutzer: ${response.status}`);
    }

    return response.json();
  }

  async getUserById(userId: string): Promise<User> {
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/users/${userId}`, {
      method: 'GET',
      headers
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `Fehler beim Abrufen des Benutzers: ${response.status}`);
    }

    return response.json();
  }

  async searchUsers(query: string): Promise<UserSearchResult[]> {
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/users/search/${encodeURIComponent(query)}`, {
      method: 'GET',
      headers
    });

    if (!response.ok) {
      throw new Error(`Fehler bei der Benutzersuche: ${response.status}`);
    }

    return response.json();
  }

  // Hilfsfunktion um Benutzerrollen-Label zu bekommen
  getUserRoleLabel(groups: string[]): string {
    if (groups.includes('telefonbuch_admin')) {
      return 'Administrator';
    } else if (groups.includes('telefonbuch_user')) {
      return 'Benutzer';
    } else if (groups.includes('telefonbuch_viewer')) {
      return 'Betrachter';
    }
    return 'Keine Berechtigung';
  }

  // Hilfsfunktion um Benutzerrollen-Farbe zu bekommen
  getUserRoleColor(groups: string[]): 'primary' | 'secondary' | 'warning' | 'error' {
    if (groups.includes('telefonbuch_admin')) {
      return 'primary';
    } else if (groups.includes('telefonbuch_user')) {
      return 'secondary';
    } else if (groups.includes('telefonbuch_viewer')) {
      return 'warning';
    }
    return 'error';
  }
}

export default new UserService();
